/**
 * Created by intellicar-rinas on 14/7/17.
 */
import React, {Component} from "react";
import "./Map.css"
import {lightTheme, darkTheme} from '../../../Layouts/config/mapConfig/mapStyleConfig'
import blueMarker from './Markers/blue-dot.png';
import greenMarker from './Markers/green-dot.png';
import redMarker from './Markers/red-dot.png';
import pulloutMarker from './Markers/pullout-dot.png';
import nocommMarker from './Markers/nocomm-dot.png';
import chargingGreenMarker from './Markers/charging-green-dot.png';
import $ from 'jquery';
import containsLatLng from './ContainsLatLng';
import {getScaleFromZoomLevel} from '../../../Layouts/config/mapConfig/mapConfig';
import getCustomIcon from './customIconsConfig';
import {vehicleStates} from '../../../constants/constants';
import startmarker from './Markers/startmarker.png';
import stopmarker from './Markers/stopmarker.png';
import {dateFormatWithSec} from '../../../constants/constants';
import moment from 'moment';

import _ from 'lodash';

let map = null;
let mapConfig;
let SCALE = 12;
// let factor = 0.75;
let factor = 1;
let listeners = {
    'zoom_changed': [],
    'tilesloaded': [],
    'mapLoaded': [],
    'click':[],
    'rightclick':[],
};
let tempMarker;

class Map extends Component{

    constructor(props){
        super(props);
        this.refLoaded = this.refLoaded.bind(this);
        this.googleLoaded = this.googleLoaded.bind(this);
        this.zoomChanged = this.zoomChanged.bind(this);
        this.tilesLoaded = this.tilesLoaded.bind(this);
        this.fitBounds = this.fitBounds.bind(this);
        this.setSize = this.setSize.bind(this);
        this.setBufferedSize = this.setBufferedSize.bind(this);
        this.mapClick = this.mapClick.bind(this);
        this.mapRightClick = this.mapRightClick.bind(this);
        window.setMapSize = this.setSize;
        window.setBufferedMapSize = this.setBufferedSize;
        // window.initMap = this.googleLoaded;
        if(!window.google){
            this.googleLoaded();
        }

        if(props.listeners){
            for(let key in listeners){
                if(key in props.listeners){
                    listeners[key] = [...listeners[key], props.listeners[key]]
                }
            }
        }
    }

    setSize(style, buffer=false) {
        if(buffer) {
            this.bufferMapStyles = style;
        } else {
            $(this.mapDiv).css(style);
        }
    }

    setBufferedSize() {
        if(this.bufferMapStyles) {
            this.setSize(this.bufferMapStyles);
            window.google.maps.event.trigger(window.map, 'resize');
            this.bufferMapStyles = null;
        }
    }

    refLoaded(div) {
        if(map)
            return;

        this.mapDiv = div;
        if(window.google){
            this.loadMap(div);
        }
    }

    googleLoaded() {
        if(this.mapDiv){
            this.loadMap(this.mapDiv);
        }
    }

    loadMap(div) {

        if(div === null)
            return;

        mapConfig = getDefaultMapConfig();
        map = new window.google.maps.Map(div, mapConfig);
        map.setOptions({minZoom:3})
        window.map = map;
        new containsLatLng();

        let searchBox = new window.google.maps.places.SearchBox(document.getElementById('pac-input'));
        map.controls[window.google.maps.ControlPosition.TOP_LEFT]
            .push(document.getElementById('pac-input'));

        window.google.maps.event.addListener(searchBox, 'places_changed', function () {

            let places = searchBox.getPlaces();
            if (places.length == 0) {
                return;
            }

            let bounds = new window.google.maps.LatLngBounds();
            places.forEach(function (place) {
                if (place.geometry.viewport) {
                    // Only geocodes have viewport.
                    bounds.union(place.geometry.viewport);
                } else {
                    bounds.extend(place.geometry.location);
                }
            });
            if(window.freezMap.active) return;
            map.fitBounds(bounds);
        });

        window.pointerMarker = new window.google.maps.Marker({
            position: {lat: -25.363, lng: 131.044},
            map,
            visible:false,
            icon: 'https://maps.google.com/mapfiles/ms/icons/blue-dot.png',
        });
        window.startMarker = new window.google.maps.Marker({
            position: {lat: -25.363, lng: 131.044},
            map,
            visible:false,
            icon: {
                url: startmarker,
                scaledSize: new window.google.maps.Size(38, 38),
            },
            title: 'Start'
        });
        window.endMarker = new window.google.maps.Marker({
            position: {lat: -25.363, lng: 131.044},
            map,
            visible:false,
            icon: {
                url: stopmarker,
                scaledSize: new window.google.maps.Size(38, 38),
            },
            title: 'End'
        });

        map.addListener('center_changed', this.tilesLoaded);
        map.addListener('zoom_changed', this.zoomChanged);
        map.addListener('click', this.mapClick);
        map.addListener('rightclick', this.mapRightClick);
        map.addListener('mousedown', e=>{ if(window.triggerMapEvent) {window.triggerMapEvent('mousedown', e)}});
        map.addListener('mousemove', e=>{ if(window.triggerMapEvent) {window.triggerMapEvent('mousemove', e)}});
        map.addListener('mouseup', e=>{ if(window.triggerMapEvent) {window.triggerMapEvent('mouseup', e)}});

        // window.google.maps.event.addDomListener(this.mapDiv, 'mousedown', function (e) {
        //     console.log(e);
        //     // return false;
        // });

        this.zoomChanged(true);

        this.callListeners('mapLoaded');

        /*
        *
        *   Private Methods
        *
        * */

        function getDefaultMapConfig() {
            let zoom = 11;
            return {
                center: window.locations.USR,
                zoom: zoom,
                // disableDefaultUI:true,
                clickableIcons: false,
                styles:lightTheme,
                keyboardShortcuts: false
            }
        }
    }



    tilesLoaded () {
        this.callListeners("tilesloaded");
    };


    zoomChanged (inital) {

        SCALE = getScaleFromZoomLevel(map.getZoom());

        if(map.getZoom() < 10) {
            if(this.mapTheme !== 'DARK') {
                map.setOptions({styles: darkTheme});
                this.mapTheme = 'DARK'
            }
        } else {
            if(this.mapTheme !== 'LIGHT') {
                map.setOptions({styles: lightTheme});
                this.mapTheme = 'LIGHT'
            }
        }

        if(!inital){
            this.callListeners("zoom_changed");
        }
    };

    callListeners(tag, msg){
        if(tag in listeners){
            for(let idx in listeners[tag]){
                listeners[tag][idx](msg);
            }
        }
    }

    addListener(tag, method){
        if(tag in listeners){
            listeners[tag].push(method);
        }
    }

    fitBounds (bounds) {
        if(this.props.freezMap && this.props.freezMap.active) return;
        map.fitBounds(bounds);
    }

    getMap() {
        return map;
    }

    mapRightClick(e) {
       this.callListeners('rightclick', e)
    }

    mapClick(e) {
        this.callListeners('click', e)
    }


    /*
    *
    *   Marker
    *
    * */

    createMarker(vehicle, deepFreeze = false){
        // console.log(vehicle)
        vehicle.marker = new window.google.maps.Marker({
            title:this.getTitle(vehicle),
            icon:this.getIcon(vehicle.stats, vehicle.filters || [], vehicle),
            map: map,
            visible:deepFreeze ? false : vehicle.markerVisible,
            position: vehicle.stats.lat && vehicle.stats.lng ? {lat:vehicle.stats.lat, lng: vehicle.stats.lng} : null
        });

        vehicle.markerUpdatedAt = moment(Date.now()).format(dateFormatWithSec);
        vehicle.markerIconUpdatedAt = moment(Date.now()).format(dateFormatWithSec);

        vehicle.marker.setVisibilty = (vehicle) => {
            if(vehicle.marker.visible !== vehicle.markerVisible){
                vehicle.marker.setVisible(vehicle.markerVisible);
            }
        };

        vehicle.marker.update = (vehicle) => {
            vehicle.markerUpdatedAt = moment(Date.now()).format(dateFormatWithSec);
            if(vehicle && vehicle.marker && vehicle.marker.updateIcon) {
                vehicle.marker.updateIcon(vehicle);
            }

            if(vehicle.stats.lat && vehicle.stats.lng) 
                vehicle.marker.setPosition({lat:vehicle.stats.lat, lng:vehicle.stats.lng});
            vehicle.marker.setVisibilty(vehicle);
        };

        vehicle.marker.updateIcon =vehicle=> {
            let changed = false;
            let iconProps = this.getIconURL(vehicle.stats, vehicle);
            let _SCALE = SCALE * iconProps.scale;

            tempMarker = {
                icon:{...vehicle.marker.icon}
            };

            if(vehicle.marker.icon.SCALE !== _SCALE){
                changed = true;
                tempMarker.icon.SCALE = _SCALE * iconProps.scale;
                tempMarker.icon.size = new window.google.maps.Size(_SCALE, _SCALE);
                tempMarker.icon.scaledSize = new window.google.maps.Size(_SCALE, _SCALE * 36);
                tempMarker.icon.anchor = new window.google.maps.Point(_SCALE / 2, _SCALE / 2);
            }

            if(vehicle.marker.icon.direction !== this.getDirection(vehicle.stats, iconProps)){
                changed = true;
                tempMarker.icon.origin = new window.google.maps.Point(0, this.getDirection(vehicle.stats, iconProps));
                tempMarker.icon.direction = this.getDirection(vehicle.stats, iconProps);
            }

            tempMarker.icon.url = iconProps.url;
            tempMarker.icon.mobilistatus = vehicle.stats.mobilistatus;
            if(vehicle.marker && vehicle.marker.icon && tempMarker.icon.url !== vehicle.marker.icon.url) {
                changed = true;
            }

            if(changed) {
                vehicle.markerIconUpdatedAt = moment(Date.now()).format(dateFormatWithSec);
                vehicle.marker.setIcon(tempMarker.icon);
            }
        };


    }


    getBounds(){
        return map.getBounds();
    }

    getIcon(stats, filters, vehicle){
        let iconProps = this.getIconURL(stats, vehicle);
        let _SCALE = SCALE * iconProps.scale;

        return {
            SCALE: _SCALE,
            direction: this.getDirection(stats, iconProps),
            mobilistatus:stats.mobilistatus,
            url: iconProps.url,
            origin: new window.google.maps.Point(0, this.getDirection(stats, iconProps)),
            size: new window.google.maps.Size(_SCALE, _SCALE),
            scaledSize: new window.google.maps.Size(_SCALE, _SCALE * 36),
            anchor: new window.google.maps.Point(_SCALE / 2, _SCALE / 2)
        };
    }
    getTitle(vehicle) {
        let driverName = null
        let phoneno = null
        if(vehicle && vehicle.vehiclemeta.chassisno) {
            let splitChassisno = vehicle.vehiclemeta.chassisno.split("-")
            if(splitChassisno.length === 2){
                driverName = splitChassisno[0]
                phoneno = splitChassisno[1]
                return vehicle.vehicleno + "\n" + "Driver Name: " +driverName +"\n" + "Phone No: " + phoneno
            }
        }
        return vehicle.vehicleno
    }

    getDirection(stats, iconProps){
        if (stats.direction == null)
            return 0;
        let direction = Math.floor(stats.direction / 10) * SCALE * iconProps.scale;
        if (direction > SCALE * iconProps.scale * 36)
            direction = SCALE * iconProps.scale * 36;
        return direction;
    }

    getIconURL(stats, vehicle){

        let filters = vehicle.filters;
        let defaultMarker = null;
        if(defaultMarker === null && filters.indexOf("concox_assettracker_charging") !== -1) { 
            vehicle.vehicleState = vehicleStates.concox_assettracker_charging;
            defaultMarker = chargingGreenMarker;
        }

        if(defaultMarker === null && filters.indexOf("devicepullout") !== -1) { 
            vehicle.vehicleState = vehicleStates.DEVICE_PULLOUT;
            defaultMarker =  pulloutMarker;
        }
        if(defaultMarker === null && filters.indexOf("immobpullout") !== -1) { 
            vehicle.vehicleState = vehicleStates.DEVICE_PULLOUT;
            defaultMarker =  pulloutMarker;
        }

        if (defaultMarker === null && filters.indexOf("nocomm") !== -1) { 
            vehicle.vehicleState = vehicleStates.NON_COMM;
            defaultMarker =  nocommMarker;
        }

        if (defaultMarker === null && filters.indexOf("immobilized") !== -1) { 
            vehicle.vehicleState = vehicleStates.IMMOBILIZED;
            defaultMarker =  redMarker;
        } else if(defaultMarker === null) {
            if (filters.indexOf("running") !== -1 || filters.indexOf("users_moving") !== -1) { 
                vehicle.vehicleState = vehicleStates.RUNNING;
                defaultMarker =  greenMarker;
            } else { 
                vehicle.vehicleState = vehicleStates.STOPPPED;
                defaultMarker =  blueMarker;
            }
        }
        
        let customIcon = getCustomIcon(vehicle);
        if(customIcon && customIcon.url[vehicle.vehicleState]) {
            return { 
                url: customIcon.url[vehicle.vehicleState],
                scale: customIcon.scale
            };
        }

        return { url: defaultMarker, scale: 1};

    }




    render() {
        return(
            <div className="inMapDivContainer">
                <input id="pac-input" className="inMapSearch" type="text" placeholder="Search..."/>
                <div className="inMapDiv" ref={r => this.refLoaded(r)}></div>
            </div>
        )
    }

    componentWillUnmount(){
        map = null;
    }

}

export default Map;